import { isSchemaRecord } from '../shared/runtime-values.js';
import { EVENT_PROP_ALLOWLIST } from '../shared/analytics-schema.js';
import { serializeErrorReport } from '../shared/error-report.js';

interface Action { event: string; age_ms: number }
const histories = new WeakMap<Window, { event: string; at: number }[]>();
const MAX_ACTIONS = 12;
const MAX_AGE_MS = 120_000;

/** Only schema event names leave the browser. No labels, map data, or input values. */
export function addErrorActionContext(event: string, props: Record<string, string>) {
  const now = Date.now();
  const history = (histories.get(window) ?? []).filter(action => now - action.at <= MAX_AGE_MS);
  if (Object.hasOwn(EVENT_PROP_ALLOWLIST, event) && !/runtime_error|console_error|performance|engagement/.test(event)) {
    history.push({ event, at: now });
  }
  histories.set(window, history.slice(-MAX_ACTIONS));
  if (!props.error_blob) return props;
  try {
    const parsed: unknown = JSON.parse(props.error_blob);
    if (!isSchemaRecord(parsed)) return props;
    const actions: Action[] = history.slice(-MAX_ACTIONS).map(action => ({ event: action.event, age_ms: Math.max(0, now - action.at) }));
    return { ...props, error_blob: serializeErrorReport({ ...parsed, app_version: props.app_version, actions }) };
  } catch { return props; }
}
